<template>
  <div>
    <button v-can:edit-exploitation class='action-btn add-btn flex items-center' @click='showAddStade'>Ajouter un stade</button>
    <table>
      <thead>
        <tr>
          <th class="has-tooltip" v-tooltip="{ content : getTooltipMessage('phenologique') }"><span>Stade phénologique repère</span></th>
          <th class="has-tooltip" v-tooltip="{ content : getTooltipMessage('dose') }"><span>Dose unitaire d'irrigation (en mm)</span></th>
          <th class="has-tooltip" v-tooltip="{ content : getTooltipMessage('temps_retour') }"><span>Temps de retour (en jours)</span></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='stade in stadesOrdered' :key='stade.id_ref_stade'>
          <td><div>{{ stade.nom }}</div></td>
          <td>
            <v-field-integer v-validate='{ required : true , min_value : 0 }' v-model.number='stade.dose' :name='stade.id_ref_stade + "_dose"' data-vv-as='dose' />
          </td>
          <td>
            <v-field-integer v-validate='{ required : true , min_value : 0 }' v-model.number='stade.periode' :name='stade.id_ref_stade + "_periode"' data-vv-as='période' />
          </td>
          <td class='align-center' v-can:edit-exploitation>
            <div><button class='action-icon delete-btn' @click='deleteRow(stade)'/></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'StadeTable',
  inject: ['$validator'],
  mixins: [mixinTooltip],

  props: {
    stades: {
      type: Array,
      required: true
    },
    idRefCulture: {
      type: Number,
      required: true
    },
    idRefStadeFin: Number
  },

  computed: {
    stadesOrdered () {
      return this.stades.slice().sort((s1, s2) => s1.ordre - s2.ordre)
    }
  },

  methods: {
    ...mapActions('confirm', ['confirm']),
    ...mapActions('select', ['select']),
    showAddStade () {
      this.select({
        title: "Ajout d'un stade",
        selector: 'v-select-stade',
        props: {
          idRefCulture: this.idRefCulture,
          idRefStadeFin: this.idRefStadeFin
        }
      }).then(value => {
        if (value !== false) {
          this.$emit('addRow', value)
        }
      })
    },
    deleteRow (idRefStade) {
      this.confirm({
        title: 'Suppression stade',
        message: 'Êtes vous-sûr de vouloir supprimer ce stade ?',
        okText: 'Supprimer'
      })
        .then(confirmation => {
          if (confirmation) {
            this.$emit('deleteRow', idRefStade)
          }
        })
    }
  }
}
</script>
